// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1,
.navbar-brand,
.navbar-nav a {
  font-family: "Open Sans", Verdana, Tahoma, Arial;
  font-weight: 400;
  font-size: 0.9em;
}

.nav-link:hover {
  color: #64c6ff !important;
}

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.75);
}

.navbar-inner,
.navbar .btn-navbar {
  border: 0px;
}

.dropdown-menu {
  background-color: rgba(0, 0, 0, 0.9); /*#343a40;*/
  background-clip: padding-box;
  border: 0px solid rgba(255, 255, 255, 0.15);
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.85em;
  font-weight: 400;
  border-radius: 0rem;
  padding: 10px;
}

.dropdown-item {
  color: #cccccc !important;
  padding: 5px;
}

.dropdown-item:hover {
  background-color: #64c6ff;
}

.dropdown-item:focus,
.dropdown-item:hover {
  color: #16181b !important;
}

.bg-dark {
  background-color: #222222 !important;
}

.navbar {
  background-image: url("https://www.cancerimagingarchive.net/wp-content/uploads/2020/03/tcia-header-bkgd.jpg");
  background-repeat: no-repeat; /* Determine what direction the image will repeat */
  background-position: center center; /* Where the image will be positioned relative to "top, right, bottom, and/or left */
  background-size: cover;
  background-position: center;
  /* -webkit-box-shadow: 0 2px 6px 0px #999;
  -moz-box-shadow: 0 2px 6px 0px #999;
  box-shadow: 0 2px 6px 0px #999;*/
}

@media (min-width: 980px) {
  /* HOVER shows dropdown, rather than click and show */
  .navbar-nav li:hover > .dropdown-menu {
    display: block;
  }
  /* FIX hover for dropdown moving slowly to dropdown hides */
  .navbar .dropdown-menu {
    margin-top: 0px;
  }
}
.navbar-toggler {
  border: 0px solid transparent;
}

@media (min-width: 980px) {
  body {
    padding-top: 0px;
  }
  .social {
    display: block;
  }
  #social-in-menu,
  .button_social_group {
    float: left;
    position: absolute;
    left: -40px;
    top: 0px;
    z-index: 100000;
    margin: 10px;
  }
}
@media (max-width: 980px) {
  body {
    padding-top: 0px;
  }
  .social {
    display: block;
  }
  #social-in-menu,
  .button_social_group {
    float: right;
    position: absolute;
    right: 80px;
    top: 13px;
    z-index: 100000;
    margin: 10px;
  }
}
@media (max-width: 540px) {
  body {
    padding-top: 0px;
  }
  .social {
    display: block;
  }
  #social-in-menu,
  .button_social_group {
    float: right;
    position: absolute;
    right: 60px;
    top: 13px;
    z-index: 100000;
    margin: 10px;
  }
  .navbar {
    padding: 0.5rem 1rem;
    padding-top: 0.5rem;
    padding-right: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.5rem;
  }
}
@media (max-width: 410px) {
  body {
    padding-top: 0px;
  }
  .social {
    display: none;
  }
  #social-in-menu,
  .button_social_group {
    float: right;
    position: absolute;
    right: 80px;
    top: 13px;
    z-index: 100000;
    margin: 10px;
  }
}
.social li {
  list-style-type: none;
  display: inline;
  padding-left: 10px;
  font-size: 0.8em;
}

.social li a {
  color: #ffffff;
  opacity: 0.6;
  transition: 0.3s;
}

.social li a:hover {
  color: #ffffff; /* 64C6FF */
  opacity: 1;
  transition: transform 0.25s ease, opacity 0.2s ease;
  transition: opacity 0.2s ease, color 0.2s ease;
  text-decoration: none;
}

.navbar-nav {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/header/universal-menu/universal-menu.component.scss"],"names":[],"mappings":"AAAA;;;EAGI,gDAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAEA;;EAEI,WAAA;AACJ;;AAEA;EACI,oCAAA,EAAA,WAAA;EACA,4BAAA;EACA,2CAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;;EAEI,yBAAA;AACJ;;AAEA;EACI,oCAAA;AACJ;;AAEA;EACI,6GAAA;EACA,4BAAA,EAAA,mDAAA;EACA,kCAAA,EAAA,oFAAA;EACA,sBAAA;EACA,2BAAA;EAEA;;kCAAA;AAEJ;;AAGA;EACI,qDAAA;EACA;IACI,cAAA;EAAN;EAGE,2DAAA;EACA;IACI,eAAA;EADN;AACF;AAIA;EACI,6BAAA;AAFJ;;AAKA;EACI;IACI,gBAAA;EAFN;EAKE;IACI,cAAA;EAHN;EAME;;IAEI,WAAA;IACA,kBAAA;IACA,WAAA;IACA,QAAA;IACA,eAAA;IACA,YAAA;EAJN;AACF;AAOA;EACI;IACI,gBAAA;EALN;EAQE;IACI,cAAA;EANN;EASE;;IAEI,YAAA;IACA,kBAAA;IACA,WAAA;IACA,SAAA;IACA,eAAA;IACA,YAAA;EAPN;AACF;AAUA;EACI;IACI,gBAAA;EARN;EAWE;IACI,cAAA;EATN;EAYE;;IAEI,YAAA;IACA,kBAAA;IACA,WAAA;IACA,SAAA;IACA,eAAA;IACA,YAAA;EAVN;EAaE;IACI,oBAAA;IACA,mBAAA;IACA,qBAAA;IACA,sBAAA;IACA,oBAAA;EAXN;AACF;AAcA;EACI;IACI,gBAAA;EAZN;EAeE;IACI,aAAA;EAbN;EAgBE;;IAEI,YAAA;IACA,kBAAA;IACA,WAAA;IACA,SAAA;IACA,eAAA;IACA,YAAA;EAdN;AACF;AAiBA;EACI,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAfJ;;AAkBA;EACI,cAAA;EACA,YAAA;EACA,gBAAA;AAfJ;;AAkBA;EACI,cAAA,EAAA,WAAA;EACA,UAAA;EACA,mDAAA;EAGA,8CAAA;EACA,qBAAA;AAhBJ;;AAmBA;EACI,gBAAA;AAhBJ","sourcesContent":["h1,\n.navbar-brand,\n.navbar-nav a {\n    font-family: \"Open Sans\", Verdana, Tahoma, Arial;\n    font-weight: 400;\n    font-size: 0.9em;\n}\n\n.nav-link:hover {\n    color: #64c6ff !important;\n}\n\n.navbar-dark .navbar-nav .nav-link {\n    color: rgba(255, 255, 255, 0.75);\n}\n\n.navbar-inner,\n.navbar .btn-navbar {\n    border: 0px;\n}\n\n.dropdown-menu {\n    background-color: rgba(0, 0, 0, 0.9); /*#343a40;*/\n    background-clip: padding-box;\n    border: 0px solid rgba(255, 255, 255, 0.15);\n    padding: 0.5rem 0;\n    margin: 0.125rem 0 0;\n    font-size: 0.85em;\n    font-weight: 400;\n    border-radius: 0rem;\n    padding: 10px;\n}\n\n.dropdown-item {\n    color: #cccccc !important;\n    padding: 5px;\n}\n\n.dropdown-item:hover {\n    background-color: #64c6ff;\n}\n\n.dropdown-item:focus,\n.dropdown-item:hover {\n    color: #16181b !important;\n}\n\n.bg-dark {\n    background-color: #222222 !important;\n}\n\n.navbar {\n    background-image: url(\"https://www.cancerimagingarchive.net/wp-content/uploads/2020/03/tcia-header-bkgd.jpg\");\n    background-repeat: no-repeat; /* Determine what direction the image will repeat */\n    background-position: center center; /* Where the image will be positioned relative to \"top, right, bottom, and/or left */\n    background-size: cover;\n    background-position: center;\n\n    /* -webkit-box-shadow: 0 2px 6px 0px #999;\n    -moz-box-shadow: 0 2px 6px 0px #999;\n    box-shadow: 0 2px 6px 0px #999;*/\n}\n\n@media (min-width: 980px) {\n    /* HOVER shows dropdown, rather than click and show */\n    .navbar-nav li:hover > .dropdown-menu {\n        display: block;\n    }\n\n    /* FIX hover for dropdown moving slowly to dropdown hides */\n    .navbar .dropdown-menu {\n        margin-top: 0px;\n    }\n}\n\n.navbar-toggler {\n    border: 0px solid transparent;\n}\n\n@media (min-width: 980px) {\n    body {\n        padding-top: 0px;\n    }\n\n    .social {\n        display: block;\n    }\n\n    #social-in-menu,\n    .button_social_group {\n        float: left;\n        position: absolute;\n        left: -40px;\n        top: 0px;\n        z-index: 100000;\n        margin: 10px;\n    }\n}\n\n@media (max-width: 980px) {\n    body {\n        padding-top: 0px;\n    }\n\n    .social {\n        display: block;\n    }\n\n    #social-in-menu,\n    .button_social_group {\n        float: right;\n        position: absolute;\n        right: 80px;\n        top: 13px;\n        z-index: 100000;\n        margin: 10px;\n    }\n}\n\n@media (max-width: 540px) {\n    body {\n        padding-top: 0px;\n    }\n\n    .social {\n        display: block;\n    }\n\n    #social-in-menu,\n    .button_social_group {\n        float: right;\n        position: absolute;\n        right: 60px;\n        top: 13px;\n        z-index: 100000;\n        margin: 10px;\n    }\n\n    .navbar {\n        padding: 0.5rem 1rem;\n        padding-top: 0.5rem;\n        padding-right: 0.5rem;\n        padding-bottom: 0.5rem;\n        padding-left: 0.5rem;\n    }\n}\n\n@media (max-width: 410px) {\n    body {\n        padding-top: 0px;\n    }\n\n    .social {\n        display: none;\n    }\n\n    #social-in-menu,\n    .button_social_group {\n        float: right;\n        position: absolute;\n        right: 80px;\n        top: 13px;\n        z-index: 100000;\n        margin: 10px;\n    }\n}\n\n.social li {\n    list-style-type: none;\n    display: inline;\n    padding-left: 10px;\n    font-size: 0.8em;\n}\n\n.social li a {\n    color: #ffffff;\n    opacity: 0.6;\n    transition: 0.3s;\n}\n\n.social li a:hover {\n    color: #ffffff; /* 64C6FF */\n    opacity: 1;\n    transition: transform 0.25s ease, opacity 0.2s ease;\n    -webkit-transition: -webkit-transform 0.25s ease,\n    opacity 0.2s ease;\n    transition: opacity 0.2s ease, color 0.2s ease;\n    text-decoration: none;\n}\n\n.navbar-nav {\n    margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
